import React, { Component } from "react";
import "./ExistingCustomers.css";

class ExistingCustomers extends Component {
	reformatValue(e) {
		let splitVal = e.target.value.split(", ");
		this.props.buildSearchQuery("existingCustomers", splitVal);
	}
	render() {
		return (
			<section>
				<p className="panel-section-header">Existing Customers</p>
				<div>
					<small>Separate multiple customers (ticker or url) by a semicolon.</small>
					<br />
					<input
						defaultValue={
							this.props.query["existingCustomers"] === undefined
								? ""
								: this.props.query["existingCustomers"]
						}
						onChange={e => this.reformatValue(e)}
						type="text"
						placeholder="e.g. AAPL; amazon.com"
					/>
				</div>
			</section>
		);
	}
}

export default ExistingCustomers;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/CustomersOptions/ExistingCustomers/ExistingCustomers.js